import { render, staticRenderFns } from "./LeyesPromulgadasList.vue?vue&type=template&id=192040a8&scoped=true&"
import script from "./LeyesPromulgadasList.vue?vue&type=script&lang=js&"
export * from "./LeyesPromulgadasList.vue?vue&type=script&lang=js&"
import style0 from "./LeyesPromulgadasList.vue?vue&type=style&index=0&id=192040a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192040a8",
  null
  
)

export default component.exports